import {Drawer, List} from 'antd'
import React from 'react'
import s from './menudrawer.module.css';
import {LoginOutlined, LogoutOutlined} from '@ant-design/icons/lib'
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {AppStateType} from "../../../store";
import {TFunction} from "i18next";
import {actions, logout} from "../../../store/actions/user";
import history from "../../../helpers/history";
import authApi from "../../../api/user";

type Item = {
    name: string
    url: string
}
type PropsType = {
    visible: boolean
    setVisible: (visible: boolean) => void
}

function getMenuItems(t: TFunction, isAuth: boolean, username: string | null) {
    let items = [
        {name: t('AboutRegistry'), url: '/#aboutRegistry'},
        /*{name: t('News'), url: '/#news'},*/
        {name: t('Registry_functions'), url: '/#functions'},
        {name: t('Payment_services'), url: '/#payment'},
        {name: t('Help'), url: '/#help'},
        {name: t('Contacts'), url: '/#contacts'}
    ] as Array<Item>
    if (isAuth && username != null) {
        items.push({name: username, url: '/home/cabinet'})
    }
    return items;
}

const MenuDrawer = (props: PropsType) => {
    const { setVisible, visible } = props;
    const {t} = useTranslation(['translation', 'resources'])
    const { isAuth, username } = useSelector((state : AppStateType ) => state.userReducer)
    const menuItems = getMenuItems(t, isAuth, username)
    const pathname = window.location.origin
    const dispatch = useDispatch()

    const handleLogOut = () => {
        authApi.logout()
            .then(response => {})
            .catch(err => {})
            .finally(()=>{
                dispatch(actions.clearAuthUserData())
                window.location.href = '/'
            })
        if (visible) { close() }
    }
    const handleLogIn = () => {
        //history.push("/login")
        window.location.href = '/account/login'
        if (visible) { close() }
    }

    const close = () => {
        setVisible( false );
    };
    let handleClick = isAuth ? handleLogOut : handleLogIn
    let auth = isAuth ? <>{t('resources:LogOut')}<LogoutOutlined /></> : <>{t('resources:LogIn')}<LoginOutlined /></>

    let linkElements = menuItems.map(n =>
        <List.Item
            key={n.name}
            className={s.listItem}
        >
            <a
                href = {n.url}
                onClick={close}
                //activeClassName={s.activeLink}
            >
                {n.name}
            </a>
        </List.Item>
    )

    return (
        <div>
            <Drawer
                key='left'
                title=""
                placement="left"
                /*closable={false}*/
                onClose={close}
                visible={visible}
                getContainer={false}
                width={300}
                className={s.drawer}
            >
                <List
                    className={s.listRoot}
                    footer={
                        <List.Item
                            className={s.loginMobile}
                            onClick = {handleClick}
                        >
                            {auth}
                        </List.Item>
                    }
                >
                    {linkElements}
                    {/*{isAuth
                ? <MenuItem className={s.loginMobile} onClick={handleLogOut}>{t('resources:LogOut')}<ExitToAppIcon /></MenuItem>
                : <MenuItem className={s.loginMobile} onClick={handleLogIn}>{t('resources:LogIn')}<LoginIcon /></MenuItem>
            }*/}
                </List>
            </Drawer>
        </div>
    );
}
export default MenuDrawer
